import { render, staticRenderFns } from "./mods.vue?vue&type=template&id=6daae835&scoped=true"
import script from "./mods.vue?vue&type=script&lang=js"
export * from "./mods.vue?vue&type=script&lang=js"
import style0 from "./mods.vue?vue&type=style&index=0&id=6daae835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daae835",
  null
  
)

export default component.exports